import { useContext } from "react"
import { PosicaoClientesContext } from "./PosicaoClientesContext"

export function usePosicaoClientesContext() {
    return useContext(PosicaoClientesContext)
}
